module.exports = __webpack_public_path__ + "img/vertical_7_1_6000.4915e0d7.png";